<div class="flex-column height-100 bg-col-w"
     [style]="client.isS || client.isM ? 'border-top-left-radius: 20px; border-top-right-radius: 20px;' : ''">
    <div class="p-a-5 b-b b-col-5 p-a-4-s p-a-4-m">
        <div class="flex flex-justify-between flex-middle">
            <p class="h3"
               *iCms="'title' of content"></p>
            <button role="button"
                    class="flex"
                    aria-label="Close"
                    (click)="close()">
                <i class="icon-close"
                   aria-hidden="true"></i>
            </button>
        </div>
    </div>

    @if (model?.data) {
    <div class="overflow-auto custom-scrollbar flex-grow p-a-5 p-a-4-s p-a-4-m">
        <ng-form class="w-12"
                 [grid]="12"
                 [gridColumnGap]="'16px'"
                 [gridRowGap]="'16px'"
                 #form="ngForm"
                 novalidate="true">
            @for (field of fields; track field; let first = $first) {

            @if(!field.is_hidden_field){
            @if(field.field_type === 'address') {
            <customform-address-fieldset [form]="form"
                                         [customFormField]="field"
                                         [gridColumn]="getFieldGridColumn(field)"
                                         [data]="data[field.cid]" />
            } @else if(isSupportedField(field.field_type)) {
            <div [gridColumn]="getFieldGridColumn(field)">
                @if(field.field_type === 'file_upload'){
                <div class="bg-col-52 p-a center"
                     style="border-radius: 12px;">
                    <span class="s1 inline-block m-b">{{field.label | translate}}</span>
                    <file-input class="block"
                                [maxSize]="getMaxSize(field)"
                                [accept]="field.image_type"
                                (fileChange)="onUpload($event, field)"
                                [inputId]="'product-view-request-quote-input-field' + field.cid"> <label
                               [buttonStyle]="'button-1'"
                               [attr.for]="'product-view-request-quote-input-field' + field.cid"
                               class="cursor-pointer">{{'select files' |
                            translate }} </label>
                    </file-input>

                </div>
                <div class="m-t">
                    <result [status]="getFileInputStatus(field)"
                            class="m-b-2 _result"></result>
                    <form-mui-field class="block m-b-2"
                                    [errorMessage]="'Please upload image' | translate">
                        <input type="hidden"
                               [name]="field.cid"
                               [(ngModel)]="data[field.cid]"
                               [required]="!!field.required">
                    </form-mui-field>
                    @if(data[field.cid]?.name){
                    <div class="flex flex-middle m-b-2">
                        <span class="p2 col-3">{{data[field.cid].name}}</span>
                        <button inlineButton
                                class="m-l-2"
                                (click)="resetFile(field)"><span class="s2"
                                  style="letter-spacing: 0;">{{'Remove' | translate}}</span></button>
                    </div>
                    }
                    @if(field.field_options?.description) {
                    <p class="p2">
                        {{field.field_options?.description | translate}}
                    </p>
                    }
                </div>
                } @else if(field.field_type === 'checkboxes'){
                @if(field.label){
                <p class="p2 m-b-2"
                   [class._required-label]="field.required">{{field.label | translate}}</p>
                }
                <!-- input: checkbox -->
                @for (option of field.field_options?.options; track option; let i = $index) {
                <checkbox>
                    <input type="checkbox"
                           [(ngModel)]="localCheckboxesData[field.cid][option.label]"
                           (ngModelChange)="localOnCheckboxesChange(field)"
                           [name]="field.cid + i">
                    {{option.label | translate}}
                </checkbox>
                }
                @if(field.field_options?.include_other_option){
                <div class="flex flex-top m-t-2">
                    <checkbox style="padding-top: 11px;">
                        <input type="checkbox"
                               [(ngModel)]="localCheckboxesData[field.cid][checkboxesOtherOptionLabel]"
                               (ngModelChange)="localOnCheckboxesChange(field)"
                               [name]="field.cid + '_other'">
                    </checkbox>
                    <form-mui-field [label]="('Other' | translate)"
                                    class="_checkboxes-other-field"
                                    [errors]="{required: ('The Other field should not be empty' | translate)}">
                        <input type="text"
                               [name]="field.cid + '_other_text'"
                               [required]="!!localCheckboxesData[field.cid][checkboxesOtherOptionLabel]"
                               [(ngModel)]="checkboxesFieldsOtherData[field.cid]">
                    </form-mui-field>
                </div>
                }

                <form-field class="block">
                    @if(field.required){
                    <input type="hidden"
                           [name]="field.cid"
                           [(ngModel)]="checkboxes[field.cid]"
                           required>
                    }
                </form-field>
                } @else if(field.field_type === 'subscription'){
                <!-- input: subscription checkbox -->
                @if(field.label){
                <p class="p2 m-b-2"
                   [class._required-label]="field.required">{{field.label | translate}}</p>
                }
                <form-field>
                    <checkbox [alignCenter]="true">
                        <input type="checkbox"
                               [name]="field.cid"
                               [required]="!!field.required"
                               [(ngModel)]="data[field.cid]">{{field?.field_options?.options?.[0]?.label | translate}}
                    </checkbox>
                </form-field>
                } @else if(field.field_type === 'radio'){
                @if(field.label){
                <p class="p2 m-b-2"
                   [class._required-label]="field.required">{{field.label | translate}}</p>
                }
                <form-field class="block">
                    <!-- input: radio -->
                    <radio-group class="flex-column"
                                 [name]="field.cid"
                                 [required]="!!field.required"
                                 [(model)]="data[field.cid]">
                        @for (option of field?.field_options?.options; track option; let i = $index) {
                        <radio-group-item class="w-12 m-t-2"
                                          [value]="option.label">
                            <span [innerHtml]="option.label | translate"></span>
                        </radio-group-item>
                        }
                    </radio-group>
                </form-field>

                } @else if(field.field_type === 'dropdown'){

                <form-mui-field class="block"
                                [label]="field.label | translate">
                    <!-- input: select -->
                    <select [name]="field.cid"
                            [required]="!!field.required"
                            [(ngModel)]="data[field.cid]">
                        @if (field.field_options?.include_blank_option) {
                        <option value=""
                                disabled
                                selected>{{(field.placeholder | translate) || ( 'Select %' | translate: field.label )}}
                        </option>
                        }
                        @for (option of field.field_options?.options; track option) {
                        <option [value]="option.value || option.label">{{option.label | translate}}</option>
                        }
                    </select>
                </form-mui-field>
                @if(isOtherForDropdownSelected(field)){
                <form-mui-field class="block m-t"
                                [errors]="{required: ('The Other field should not be empty' | translate)}"
                                [label]="('Enter your answer' | translate)">

                    <input type="text"
                           [name]="field.cid + '_other'"
                           [required]="true"
                           [(ngModel)]="dropdownFieldsOtherData[field.cid]">
                </form-mui-field>
                }
                } @else {

                <form-mui-field class="block"
                                [label]="field.field_type === 'subscription' ? undefined :  (field.label | translate)">
                    @switch (field.field_type) {


                    <!-- input: text -->
                    @case ('text') {
                    <input type="text"
                           [name]="field.cid"
                           [required]="!!field.required"
                           [(ngModel)]="data[field.cid]"
                           [placeholder]="(field.placeholder | translate )|| ''">
                    }
                    @case ('phone') {
                    <input type="text"
                           [name]="field.cid"
                           [required]="!!field.required"
                           [(ngModel)]="data[field.cid]"
                           [placeholder]="(field.placeholder | translate )|| ''">
                    }
                    <!-- input: number -->
                    @case ('number') {
                    <input type="number"
                           [name]="field.cid"
                           [required]="!!field.required"
                           [(ngModel)]="data[field.cid]"
                           [placeholder]="(field.placeholder | translate) || ''">
                    }
                    <!-- input: email -->
                    @case ('email') {
                    <input type="email"
                           validatePattern="email"
                           [name]="field.cid"
                           [required]="!!field.required"
                           [(ngModel)]="data[field.cid]"
                           [placeholder]="(field.placeholder | translate) || ''">
                    }
                    <!-- input: textarea -->
                    @case ('paragraph') {
                    <div>
                        <textarea [name]="field.cid"
                                  [required]="!!field.required"
                                  [(ngModel)]="data[field.cid]"
                                  (keydown)="detectChanges()"
                                  (keyup)="detectChanges()"
                                  [maxlength]="field.field_options?.maxlength || null"
                                  [minlength]="field.field_options?.minlength || null"
                                  [placeholder]="(field.placeholder | translate) || ''"></textarea>
                        @if(field.field_options?.maxlength){
                        <div class="flex flex-justify-between m-t-1 p-l c1 col-11">
                            <span>{{'Characters' | translate}}</span>
                            <span>{{data[field.cid]?.length || 0}}/{{field.field_options?.maxlength}}</span>
                        </div>
                        }
                    </div>
                    }
                    }
                </form-mui-field>
                }
            </div>
            }
            }
            }

        </ng-form>
    </div>
    <div class="w-12 center p-l-5 p-r-5 p-t-3 p-b-3 b-t b-col-5 p-l-4-s p-l-4-m p-r-4-s p-r-4-m"
         style="box-shadow: 0px 1px 12px 0px #2121211A;">
        @if(showCaptcha){
        <button [status]="status"
                [buttonStyle]
                class="w-12"
                [googleRecaptchaData]="captchaData"
                [googleRecaptchaStatus]="status"
                [googleRecaptcha]="captchaSubmit">{{(model?.data?.submit_button_text || 'Send') | translate}}</button>
        } @else {

        <button [status]="status"
                [buttonStyle]
                class="w-12"
                (click)="submit()">{{(model?.data?.submit_button_text || 'Send') | translate}}</button>
        }
        @if (status.error) {
        <result [status]="status"
                class="block m-t-1 _result"></result>
        }
    </div>
    }
</div>